export default {
  namespaced: true,
  state: {
    userBaedal: [],
    delivering: [],
    delivered: []
  },
  mutations: {
    setUserBaedal: (state, userBaedal) => {
      state.userBaedal = userBaedal
    },
    setDelivered: (state, delivered) => {
      state.delivered = delivered
    },
    setDelivering: (state, delivering) => {
      state.delivering = delivering
    }
  },
  getters: {
    existsDelivering: state => () => state.delivering.length > 0,
    existsDelivered: state => () => state.delivered.length > 0,
    getUserBaedal: state => () => state.userBaedal
  }
}
